﻿'use strict';

angular.module('ntmApp').factory('YearlyRecurrence', ['Recurrence', 'Constants', function (Recurrence, Constants) {

    function YearlyRecurrence() {
        Recurrence.call(this);

        var self = this;

        var DEFAULT_VALUES = {
            startsOnDate: new Date(moment().set('month', 0).set('date', 1))
        };

        self.displaySchedulingLeeway = function () {
            return true;
        };

        self.displayOccurenceLimit = function () {
            return true;
        };

        self.displaySchedulingSettings = function () {
            return 'ng1/src/setup/recurrence/templates/scheduling-settings.html';
        };

        self.hideStartsOnDateBasedOnConditions = function () {
            return false;
        };

        self.getSettingsTemplate = function () {
            return self.scheduleRacksOnDiffDays() ? 'ng1/src/setup/recurrence/templates/yearly-rack-settings.html' :
                                                    'ng1/src/setup/recurrence/templates/yearly-scheduling-settings.html';
        };

        self.getFieldsListForSave = function () {
            var fieldsList = self.getGeneralFieldsListForSave();

            fieldsList.startsOnDate = self.startsOnDate;

            if (self.scheduleRacksOnDiffDays()) {

                if (self.allowSetupRacks) {
                    fieldsList.scheduleRacksEveryYearNumber = self.scheduleRacksEveryYearNumber;
                    fieldsList.recurrenceRacks = getRackItemsFieldsForSave(self.rackItems);
                }
            } else {

                fieldsList.everyNumbersOfYears = self.everyNumbersOfYears;

                switch (parseInt(self.occurenceYearlyType)) {
                    case Constants.Recurrence.Patterns.YEARLY.Options.On_Anniversary.value:
                        fieldsList.monthYearOnAnniversaryType = self.monthYearOnAnniversaryType;
                        fieldsList.dayYearOnAnniversaryType = self.dayYearOnAnniversaryType;
                        fieldsList.dateComposition = [ { month: self.monthYearOnAnniversaryType, day: self.dayYearOnAnniversaryType } ];
                        break;
                    case Constants.Recurrence.Patterns.YEARLY.Options.On_Selection.value:
                        fieldsList.monthNumberYearlyType = self.monthNumberYearlyType;
                        fieldsList.monthDayYearlyType = self.monthDayYearlyType;
                        fieldsList.monthYearOnSelectionType = self.monthYearOnSelectionType;
                        break;
                    default:
                        break;
                }
            }

            fieldsList.beforeLeeway = self.beforeLeeway;
            fieldsList.afterLeeway = self.afterLeeway;

            return fieldsList;
        };

        self.getRequestData = function () {

            var request = self.getGeneralRequestData();

            request.dateStart = self.startsOnDate.value;

            if (self.scheduleRacksOnDiffDays()) {

                if (self.allowSetupRacks) {
                    request.everyYearly = self.scheduleRacksEveryYearNumber.value;
                    request.recurrenceRacks = getRackItemsRequestInfo(self.rackItems);
                }
            } else {
                request.everyYearly = self.everyNumbersOfYears.value;
                request.occursYearlyType = self.occurenceYearlyType;

                switch (parseInt(self.occurenceYearlyType)) {
                    case Constants.Recurrence.Patterns.YEARLY.Options.On_Anniversary.value:
                        request.monthYearOnAnniversaryType = self.monthYearOnAnniversaryType.value;
                        request.yearDay = self.dayYearOnAnniversaryType.value;
                        break;
                    case Constants.Recurrence.Patterns.YEARLY.Options.On_Selection.value:
                        request.monthNumberYearlyType = self.monthNumberYearlyType.value;
                        request.monthDayYearlyType = self.monthDayYearlyType.value;
                        request.monthYearOnSelectionType = self.monthYearOnSelectionType.value;
                        break;
                    default:
                        break;
                }
            }

            request.beforeLeeway = self.beforeLeeway.value;
            request.afterLeeway = self.afterLeeway.value;

            return request;
        };

        self.applyDefaultInfo = function (data) {
            self.applyGeneralDefaultInfo(data);
        };

        self.setSpecificDefaultInfo = function () {
            if (!self.startsOnDate) {
                self.startsOnDate = { value: DEFAULT_VALUES.startsOnDate };
            } else if (self.startsOnDate && !self.startsOnDate.value) {
                self.startsOnDate.value = DEFAULT_VALUES.startsOnDate;
            }
        };

        self.checkForDynamicRestricts = function (field, fieldName) {

            switch (fieldName) {
                case 'startsOnDate':
                    field.restricts.allowNullable = false;

                    break;
                default:
                    break;
            }
        };

        self.equals = function (recurrence) {

            if (!self.compareGeneralInfo(recurrence)) {
                return false;
            }

            if (!self.areDaysEqual(self.startsOnDate.value, recurrence.startsOnDate.value)) {
                return false;
            }

            if (parseInt(self.beforeLeeway.value) !== parseInt(recurrence.beforeLeeway.value)) {
                return false;
            }

            if (parseInt(self.afterLeeway.value) !== parseInt(recurrence.afterLeeway.value)) {
                return false;
            }

            if (!self.areDaysEqual(self.occurenceLimitEndsOnDate.value, recurrence.occurenceLimitEndsOnDate.value)) {
                return false;
            }

            if (self.scheduleRacks !== recurrence.scheduleRacks) {
                return false;
            }

            if (self.scheduleRacksOnDiffDays()) {

                if (parseInt(self.scheduleRacksEveryYearNumber.value) !== parseInt(recurrence.scheduleRacksEveryYearNumber.value)) {
                    return false;
                }
                
                if (self.rackItems && recurrence.rackItems) {

                    for (var i = 0; i < self.rackItems.length; i++) {

                        if (parseInt(self.rackItems[i].yearlyDayPrefix.value) !== parseInt(recurrence.rackItems[i].yearlyDayPrefix.value)) {
                            return false;
                        }

                        if (parseInt(self.rackItems[i].yearlyDay.value) !== parseInt(recurrence.rackItems[i].yearlyDay.value)) {
                            return false;
                        }

                        if (parseInt(self.rackItems[i].month.value) !== parseInt(recurrence.rackItems[i].month.value)) {
                            return false;
                        }

                    }
                }

            } else {

                if (parseInt(self.everyNumbersOfYears.value) !== parseInt(recurrence.everyNumbersOfYears.value)) {
                    return false;
                }

                if (parseInt(self.occurenceYearlyType) !== parseInt(recurrence.occurenceYearlyType)) {
                    return false;
                }

                switch (parseInt(self.occurenceYearlyType)) {
                    case Constants.Recurrence.Patterns.YEARLY.Options.On_Anniversary.value:

                        if (parseInt(self.monthYearOnAnniversaryType.value) !== parseInt(recurrence.monthYearOnAnniversaryType.value)) {
                            return false;
                        }

                        if (parseInt(self.dayYearOnAnniversaryType.value) !== parseInt(recurrence.dayYearOnAnniversaryType.value)) {
                            return false;
                        }

                        break;

                    case Constants.Recurrence.Patterns.YEARLY.Options.On_Selection.value:

                        if (parseInt(self.monthNumberYearlyType.value) !== parseInt(recurrence.monthNumberYearlyType.value)) {
                            return false;
                        }

                        if (parseInt(self.monthDayYearlyType.value) !== parseInt(recurrence.monthDayYearlyType.value)) {
                            return false;
                        }

                        if (parseInt(self.monthYearOnSelectionType.value) !== parseInt(recurrence.monthYearOnSelectionType.value)) {
                            return false;
                        }

                        break;

                    default:
                        break;
                }

            }

            return true;
        };

        function getRackItemsFieldsForSave(rackItems) {

            if (rackItems) {
                return rackItems.map(function (item) {

                    return {
                        monthNumberYearlyType: item.yearlyDayPrefix,
                        monthDayYearlyType: item.yearlyDay,
                        monthYearType: item.month
                    };
                });
            }

            return [];
        }

        function getRackItemsRequestInfo(rackItems) {

            if (rackItems) {
                return rackItems.map(function (item) {

                    return {
                        ccrackID: item.ccrackID,
                        rackId: item.rackId,
                        cageCount: item.cageCount,
                        monthNumberYearlyType: parseInt(item.yearlyDayPrefix.value),
                        monthDayYearlyType: parseInt(item.yearlyDay.value),
                        monthYearType: parseInt(item.month.value)
                    };
                });
            }

            return [];
        }

        function initialize() {
            self.patternType = Constants.Recurrence.Patterns.YEARLY.value;
            self.occurenceYearlyType = Constants.Recurrence.Patterns.YEARLY.Options.On_Anniversary.value;
            self.datePickerOptions = { datepickerMode: 'year', minMode: 'year', templateString: 'y' };
        }

        initialize();
    }

    YearlyRecurrence.prototype = Object.create(Recurrence.prototype);
    YearlyRecurrence.prototype.constructor = Recurrence;

    return (YearlyRecurrence);

}]);